import { getDefaultRoutePrefix } from '../core/config/runtimeConfig';
import { useRouteStore } from '../core/store/route.store';

export const ROUTE_PREFIX = getDefaultRoutePrefix();

export const PRIVATE_ROUTE_PATHS = {
  dashboard: '/dashboard',
  jobs: '/job',
} as const;

// Get the current route prefix (can be called outside of React components)
export const getRoutePrefix = () => {
  return useRouteStore.getState().routePrefix;
};

// Dynamic route function that uses the current route prefix from the store
export const route = (path: string) => `${getRoutePrefix()}${path}`;

// Hook version for use in React components (reactive to changes)
export const useRoute = () => {
  const routePrefix = useRouteStore((state) => state.routePrefix);
  return (path: string) => `${routePrefix}${path}`;
};
